<template>
  <div>
    <Header
      :history="history"
      :data="drawerData"
      @goBack="goBack"
      @close="close"
      @reload="loadData"
    />

    <transition name="fade">
      <div v-if="isSuccess">
        <div class="content__title__container" data-js="get-height">
          <h2 class="content__title">{{ data.name || '-' }}</h2>
          <div v-if="isValidObject(drawerData) && drawerData.employee && drawerData.employee.externalId">
            <span class="gray-6--text">{{ $t(`${namespace}.externalId`) }}:</span> {{ drawerData.employee.externalId }}
          </div>
        </div>

        <Tabs
          :data="drawerData"
          :drawerType="drawerType"
          :filters="filters"
          @change="change"
        />
      </div>
    </transition>

    <div
      v-if="isLoading"
      class="progress__wrapper text-xs-center py-5"
      :style="`height: ${contentHeight}px`"
    >
      <div class="progress">
        <v-progress-circular indeterminate color="primary" />
      </div>
    </div>
  </div>
</template>

<script>
import requestStatusMixin from 'mixins/requestStatus'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { hasRole } from 'utils/functions'
import { isValidObject, calcContentHeight, catchError } from 'corp-front-vue-commons/src/utils/functions'
import Header from './Header'
import Tabs from './Tabs'

export default {
  name: 'Employee',
  mixins: [requestStatusMixin],
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    history: {
      type: Array,
      default: () => []
    },
    drawerType: {
      type: String,
      required: true
    },
    filters: {
      type: Object
    }
  },
  components: {
    Header,
    Tabs
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.employee.tabs',
      drawerData: {},
      contentHeight: 'none'
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    isValidObject (val) {
      return isValidObject(val)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    goBack () {
      this.$emit('goBack')
    },

    close (reload) {
      this.$emit('close', reload)
    },

    change (val) {
      this.$emit('change', val)
    },

    async loadData () {
      if (this.isLoading || !this.hasRole('employee', 'ROLE_GET_EMPLOYEE_ID')) {
        this.setStatus(STATUS_SUCCESS)
        return
      }

      this.setStatus(STATUS_IS_LOADING)

      try {
        const { data: res } = await this.$apiService.employee.getById(this.data.id)

        this.drawerData = {
          employeeId: this.data.id,
          ...res.data
        }

        this.$emit('updateHistory', {
          drawerType: 'employee',
          data: this.data
        })

        this.setStatus(STATUS_SUCCESS)
      } catch (error) {
        this.setStatus(STATUS_FAILED)
        catchError(error)
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        this.loadData()
      }
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
    this.loadData()
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss" scoped>
.progress__wrapper {
  position: relative;
}

.progress {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%)
}

.content__title__container {
  padding: 22px 24px;
  text-align: center;
}

.content__title {
  color: var(--gray-7);
  font-family: $title-font + 1px;
  font-size: $base-font-size;
  font-weight: 700;
  text-align: center;
}
</style>
